import { render, staticRenderFns } from "./ContactShareRequest.vue?vue&type=template&id=0bd89d5c&scoped=true"
import script from "./ContactShareRequest.vue?vue&type=script&lang=js"
export * from "./ContactShareRequest.vue?vue&type=script&lang=js"
import style0 from "./ContactShareRequest.vue?vue&type=style&index=0&id=0bd89d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd89d5c",
  null
  
)

export default component.exports